import React from "react";

const FinancialLedgerList = React.lazy(() => import('src/pages/financial_ledger/FinancialLedgerList'));
const ViewFinancialLedger = React.lazy(() => import('src/pages/financial_ledger/ViewFinancialLedger'));

const routes = [
    { path: '/dashboard/financial-ledger-list/:param', withParam: true, exact: true, name: "", element: ViewFinancialLedger },
    { path: '/dashboard/financial-ledger-list', name: 'Transactions', element: FinancialLedgerList },
];

export default routes;
